/* eslint-disable no-duplicate-case */
import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialMarketplaceState = {
  dataMarketplaceCategories: [],
  dataMarketplaceCategoriesStatus: STATUS.IDLE,
  dataMarketplaceFeeds: [],
  dataMarketplaceFeedsStatus: STATUS.IDLE,
  dataMarketplaceFeedOptions: [],
  dataMarketplaceFeedOptionsStatus: STATUS.IDLE,
  dataMarketplaceDownloadStatus: STATUS.IDLE,
  dataMarketplaceDownloadLink: '',
};

export default (state = initialMarketplaceState, action) => {
  switch (action?.type) {
    case types.LOAD_DATA_MARKETPLACE_CATEGORIES: {
      return {
        ...state,
        dataMarketplaceCategoriesStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_DATA_MARKETPLACE_CATEGORIES): {
      return {
        ...state,
        dataMarketplaceCategoriesStatus: STATUS.LOADED,
        dataMarketplaceCategories: action?.payload?.results,
      };
    }
    case reject(types.LOAD_DATA_MARKETPLACE_CATEGORIES): {
      return {
        ...state,
        dataMarketplaceCategoriesStatus: STATUS.ERROR,
        error: true,
        dataMarketplaceCategories: [],
      };
    }

    case types.LOAD_DATA_MARKETPLACE_FEEDS: {
      return {
        ...state,
        dataMarketplaceFeedsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_DATA_MARKETPLACE_FEEDS): {
      return {
        ...state,
        dataMarketplaceFeedsStatus: STATUS.LOADED,
        dataMarketplaceFeeds: action?.payload,
      };
    }

    case types.LOAD_DATA_MARKETPLACE_FEED_OPTIONS: {
      return {
        ...state,
        dataMarketplaceFeedOptionsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_DATA_MARKETPLACE_FEED_OPTIONS): {
      return {
        ...state,
        dataMarketplaceFeedOptionsStatus: STATUS.LOADED,
        dataMarketplaceFeedOptions: action?.payload,
      };
    }

    case types.DOWNLOAD_DATA_MARKETPLACE_FEED: {
      return {
        ...state,
        dataMarketplaceDownloadStatus: STATUS.LOADING,
        dataMarketplaceDownloadLink: action?.payload,
      };
    }
    case resolve(types.DOWNLOAD_DATA_MARKETPLACE_FEED): {
      return {
        ...state,
        dataMarketplaceDownloadStatus: STATUS.LOADED,
        dataMarketplaceDownloadLink: action?.payload,
      };
    }

    case types.CLEAR_DATA_MARKETPLACE_FEEDS: {
      return {
        ...state,
        dataMarketplaceFeeds: [],
        dataMarketplaceFeedsStatus: STATUS.IDLE,
        dataMarketplaceFeedOptions: [],
        dataMarketplaceFeedOptionsStatus: STATUS.IDLE,
        dataMarketplaceDownloadStatus: STATUS.IDLE,
        dataMarketplaceDownloadLink: '',
      };
    }

    default:
      return state;
  }
};
